export const CANVAS_OVERSAMPLE = 2;

export const WHEEL_CANVAS_COLORS = {
  green: "#32ab5e",
  red: "#ca3333",
  gold: "#c58b3e",
  orange: "#ff570a",
  white: "#ffffff",
} as const;

export const toRadians = (angle: number) => ((angle - 90) * Math.PI) / 180;

export const getSectorStrokeWidth = (sectorAngle: number) => {
  if (sectorAngle < 0.75) return 0.25;
  if (sectorAngle < 1.5) return 0.45;
  if (sectorAngle < 3) return 0.7;

  return 1;
};
